// extracted by mini-css-extract-plugin
export default {"pageContainer":"ProfilePages_pageContainer__NtcsO","leftSection":"ProfilePages_leftSection__hwtsE","rightSection":"ProfilePages_rightSection__epsxO"};